import { useQuery } from '@tanstack/react-query';

// models
import {
    AttributeQueryParams,
    PaginatedContactAttributeModal,
} from '../../models/contact_attributes.model';

// services
import API from '../../services/api';

// helper
import _queryKeys from './_queryKeys';

const getAttributes = async (
    queryParams?: AttributeQueryParams,
): Promise<PaginatedContactAttributeModal> => {
    const { data } = await API.getAttributes(queryParams);

    return data;
};

export default function useAttributesQuery(queryParams: AttributeQueryParams) {
    return useQuery({
        queryKey: _queryKeys.attributesParams(queryParams),
        queryFn: () => getAttributes(queryParams),
        staleTime: 1000 * 24 * 60 * 60,
    });
}
